import { render, staticRenderFns } from "./GroupRoleForm.vue?vue&type=template&id=1a9097fe"
import script from "./GroupRoleForm.vue?vue&type=script&lang=js"
export * from "./GroupRoleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports